import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface DeleteVentState {
  confirm: string;
}
const formSlice = createGenericFormSlice({
  name: "deleteVent",
  initialState: {} as SliceState<DeleteVentState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const deleteVentReducer = formSlice.reducer;
export default deleteVentReducer;
